export const name = "EXP";
export const summary = `Computes \`e\` to the power of \`X\`.`;
export const reference = `
## EXP

Computes \`e\` to the power of \`X\`.

\`\`\`
EXP(X)
\`\`\`

### Description

Computes _e_ to the power of X, also called the natural exponential function. If the result underflows, this function returns a zero. Generates an error if the result overflows.

| X | EXP(X) |
| --- | --- |
| 0.0 | 1.0 |
| \`+inf\` | \`+inf\` |
| \`-inf\` | 0.0 |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
